import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const CreatePINLazy = lazyLoader(
  () => import('./CreatePIN' /* webpackChunkName: "create-pin" */),
);

const createPINComponent = () => {
  return (
    <Suspense fallback={null}>
      <CreatePINLazy />
    </Suspense>
  );
};

export default createPINComponent;
